import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  constructor(private http: HttpClient, private apiService: ApiService) { }
  apiUrl = `${this.apiService.apiUrl}/cache`;

  clearCache(): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}`);
  }
}
